import { Duplexer } from '@wix/duplexer-js';
import { getCurrentInstance } from '@wix/business-manager-api';
import { useEffect, useMemo } from 'react';
const SIDE_EFFECT_CHANNEL_NAME = '@ai-assistant--side-effect';
const CHAT_APP_DEF_ID = '68b3f052-8532-4cb1-ba55-79af4165538f';
export const useSideEffectsConnection = _ref => {
  let {
    instanceIdForSideEffects
  } = _ref;
  const {
    isUserChannel,
    connection
  } = useMemo(() => {
    const authToken = instanceIdForSideEffects ?? (getCurrentInstance == null ? void 0 : getCurrentInstance(CHAT_APP_DEF_ID)) ?? '';
    const duplexerSocketsServerUrl = 'duplexer.wix.com';
    const instanceUpdater = {
      getInstance() {
        return authToken;
      }
    };
    const duplexer = new Duplexer(duplexerSocketsServerUrl, {
      instanceUpdater
    });
    return {
      isUserChannel: !authToken,
      connection: duplexer.connect({
        appDefId: CHAT_APP_DEF_ID
      })
    };
  }, [instanceIdForSideEffects]);
  useEffect(() => {
    return () => void (connection == null ? void 0 : connection.disconnect());
  }, [connection]);
  const channel = useMemo(() => {
    if (!connection) {
      return undefined;
    }
    return isUserChannel ? connection.subscribeToUserChannel() : connection.subscribe(SIDE_EFFECT_CHANNEL_NAME);
  }, [connection, isUserChannel]);
  useEffect(() => {
    return () => void (channel == null ? void 0 : channel.unsubscribe());
  }, [channel]);
  return {
    channel
  };
};
//# sourceMappingURL=useSideEffectsConnection.js.map